<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color="azure">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <form @submit.prevent="submit">
                <card type="login">
                  <h3 slot="header" class="header text-center">Admin Login</h3>

                  <fg-input v-model="model.email" addon-left-icon="nc-icon nc-single-02" type="email"
                    placeholder="Email"></fg-input>

                  <fg-input v-model="model.password" addon-left-icon="nc-icon nc-key-25" placeholder="Password"
                    type="password"></fg-input>

                  <br />

                  <p-button native-type="submit" slot="footer" type="info" round block class="mb-3">Login</p-button>
                </card>
              </form>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background" style="background-image: url(static/img/background/bg-main.webp) "></div>
      </div>
    </div>
  </div>
</template>
<script>
  // @ts-nocheck

  import { Button, Card, Checkbox } from "src/components/UIComponents";
  import swal from "sweetalert2";
  import AppFooter from "./Layout/AppFooter.vue";
  import AppNavbar from "./Layout/AppNavbar.vue";
  export default {
    components: {
      Card,
      AppNavbar,
      AppFooter,
      [Checkbox.name]: Checkbox,
      [Button.name]: Button
    },
    data() {
      return {
        model: {
          email: "",
          password: ""
        }
      };
    },
    methods: {
      toggleNavbar() {
        document.body.classList.toggle("nav-open");
      },
      closeMenu() {
        document.body.classList.remove("nav-open");
        document.body.classList.remove("off-canvas-sidebar");
      },
      submit() {
        try {
          this.$store
            .dispatch("auth/login", {
              email: this.model.email,
              password: this.model.password,
              userType: "Admin"
            })
            .then(() => {
              swal({
                title: `Logged in!`,
                text: "You have logged in as " + this.model.email,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success btn-fill",
                type: "success"
              })
              this.$router.push('adminHome');
            })
            .catch(error => {
              this.$store.dispatch("auth/logout");
              swal({
                title: `Error`,
                text: error.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-success btn-fill",
                type: "warning"
              });
            });
        } catch (error) {
          console.log({ error });
        }
      }
    },
    beforeDestroy() {
      this.closeMenu();
    }
  };
</script>
<style></style>
